import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import "./KontaktneUdaje.scss";

// prop types
import odberatelPropTypes from "../../propTypes/odberatelPropTypes";

// routes
import Routes from "../../constants/Routes";

// actions
import * as appHeaderActions from "../../actions/appHeaderActions";

class KontaktneUdaje extends React.Component {
  componentDidMount() {
    const { showAppHeader, changeHeaderTitle } = this.props;

    showAppHeader(false);
    changeHeaderTitle("");
  }

  render() {
    return (
      <div className="row m-0">
        <div className="col12 offset-1 pt-4">
          {/* Title */}
          <div className="row m-0">
            <h1>Zmena kontaktných údajov</h1>
          </div>
          <div className="row m-0">
            {this.props.odberatel && (
              <h4>{`Pre odberateľa: ${this.props.odberatel.NAZOV}`}</h4>
            )}
          </div>
          {/* BODY */}
          <div className="row m-0 pt-4">
            <div>
              <br />
              Ak sa zmenili Vaše kontaktné údaje (telefónne číslo, email,
              korešpodenčná adresa), ich aktualizáciu môžete vykonať na tomto{" "}
              <a href={`#${Routes.FORM_ZMENA_KONTAKTNE_UDAJE}`}>formulári</a>.
              <br />
              <br />
              <b>Upozornenie:</b> Vykonajú sa IBA zmeny kontaktných údajov.
              <br />
              Zmenu ostatných zmluvných údajov (zmluvná osoba, adresa odberného
              miesta, časová platnosť zmluvy,...) <br />
              je potrebné urobiť osobne v klientskom centre dodávateľa.
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    odberatel: state.odberatel.data,
  };
};

const mapDispatchToProps = (dispatch) => ({
  changeHeaderTitle: (title) =>
    dispatch(appHeaderActions.changeHeaderTitle(title)),
  showAppHeader: (show) => dispatch(appHeaderActions.showAppHeader(show)),
});

KontaktneUdaje.propTypes = {
  changeHeaderTitle: PropTypes.func,
  changeOdberatel: PropTypes.func,
  odberatel: odberatelPropTypes.odberatel,
  showAppHeader: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(KontaktneUdaje);
